import React from 'react';

export default function TGChibi({ 
  size = 'md', 
  animation = 'none', 
  message = '', 
  position = 'static',
  className = '',
  showSpeechBubble = false,
  speechBubbleText = "I'm here to help! 🛡️"
}) {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    '2xl': 'w-24 h-24',
    '3xl': 'w-32 h-32'
  };

  const animationClasses = {
    none: '',
    bounce: 'animate-bounce',
    pulse: 'animate-pulse',
    spin: 'animate-spin',
    ping: 'animate-ping',
    float: 'animate-bounce',
    wiggle: 'hover:animate-pulse'
  };

  const positionClasses = {
    static: '',
    fixed: 'fixed',
    absolute: 'absolute',
    relative: 'relative',
    'bottom-right': 'fixed bottom-4 right-4',
    'bottom-left': 'fixed bottom-4 left-4',
    'top-right': 'fixed top-4 right-4',
    'top-left': 'fixed top-4 left-4'
  };

  return (
    <div className={`${positionClasses[position]} ${className}`}>
      <div className="relative inline-block">
        <img 
          src="/TGChibi.png" 
          alt="TypoGuard Mascot" 
          className={`${sizeClasses[size]} object-contain ${animationClasses[animation]} cursor-pointer transition-transform hover:scale-110`}
          title={message || "TypoGuard Assistant"}
        />
        
        {showSpeechBubble && (
          <div className="absolute -top-12 -left-2 bg-gray-800 text-xs px-3 py-2 rounded-lg shadow-lg border border-gray-600 text-gray-300 opacity-0 hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-10">
            {speechBubbleText}
            <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        )}
        
        {message && !showSpeechBubble && (
          <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs text-gray-400 text-center whitespace-nowrap">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

// Predefined TGChibi variants for common use cases
export const TGChibiVariants = {
  // Loading states
  Loading: (props) => (
    <TGChibi 
      size="3xl" 
      animation="pulse" 
      message="Working on it..." 
      showSpeechBubble={true}
      speechBubbleText="Scanning for threats... 🔍"
      {...props} 
    />
  ),
  
  // Success states
  Success: (props) => (
    <TGChibi 
      size="md" 
      animation="bounce" 
      showSpeechBubble={true}
      speechBubbleText="All done! ✅"
      {...props} 
    />
  ),
  
  // Error states
  Error: (props) => (
    <TGChibi 
      size="md" 
      animation="wiggle" 
      showSpeechBubble={true}
      speechBubbleText="Oops! Something went wrong 😅"
      {...props} 
    />
  ),
  
  // Empty states
  Empty: (props) => (
    <TGChibi 
      size="lg" 
      animation="none" 
      showSpeechBubble={true}
      speechBubbleText="Nothing to see here! 👀"
      {...props} 
    />
  ),
  
  // Welcome/Helper
  Helper: (props) => (
    <TGChibi 
      size="md" 
      animation="float" 
      showSpeechBubble={true}
      speechBubbleText="Need help? I'm here! 🤝"
      {...props} 
    />
  ),
  
  // Floating assistant
  FloatingAssistant: (props) => (
    <TGChibi 
      size="lg" 
      animation="bounce" 
      position="bottom-right"
      showSpeechBubble={true}
      speechBubbleText="Click me for help! 💡"
      className="z-50 cursor-pointer hover:scale-110 transition-transform"
      {...props} 
    />
  )
};
